// extracted by mini-css-extract-plugin
module.exports = {"ContactPage":"contact_ContactPage__WDAyL","Title":"contact_Title__7b2Ft","Subtitle":"contact_Subtitle__pXKRE"};